import * as React from "react";
import { UitkLayoutFlex } from "../uitk-react-layout-flex/index.js";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkToolbarContainerTags } from "./types.js";
export class UitkToolbarContainer extends React.Component {
  static displayName = "UitkToolbarContainer";
  static defaultProps = {
    tag: "div"
  };
  render() {
    const { className, children, tag, style } = this.props;
    const toolbarHeaderTag = tag && UitkToolbarContainerTags.get(tag) || UitkToolbarContainerTags.get("div");
    const wrapperClassNames = classNames("uitk-toolbar", className);
    return /* @__PURE__ */ React.createElement(UitkLayoutFlex, { alignItems: "center", className: wrapperClassNames, style, tag: toolbarHeaderTag }, children);
  }
}
